/**
 * Reflects the rate at which credit cards
 * can be added within a backend-specified
 * time interval.
 *
 * @see {@link https://github.com/reverbdotcom/reverb/blob/master/app/reverb/credit_cards/added_storage.rb Core - Reverb::CreditCards::AddedStorage}
 */
export const CREDIT_CARD_LIMIT = 5;
